export * from './src/academy-certifications-v1-account-certification-account-certifications.meta.js';
